import React, { useState } from 'react';
import StoryboardCreatorsTable from './StoryboardCreatorsTable';
import Pagination from './Pagination';
import MainSupplyModal from './MainSupplyModal';

const mockData = Array.from({ length: 50 }, (_, i) => ({
  id: i + 1,
  storyboardId: `12345${i}`,
  name: 'Lorem Ipsum',
  count: 25,
  allCount: 1234,
  type: 'Simple',
  shelfCode: '54,355',
  mainSupply: 'Lorem Ipsum',
}));

const sampleItems = [
  { id: 1, image: 'https://via.placeholder.com/150', description: 'Lorem ipsum dolor sit amet consectetur.' },
  { id: 2, image: 'https://via.placeholder.com/150', description: 'Lorem ipsum dolor sit amet consectetur.' },
  { id: 3, image: 'https://via.placeholder.com/150', description: 'Lorem ipsum dolor sit amet consectetur.' },
  { id: 4, image: 'https://via.placeholder.com/150', description: 'Lorem ipsum dolor sit amet consectetur.' },
];

const StoryboardCreator: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSupply, setSelectedSupply] = useState<any>(null);
  const pageSize = 10;

  const handlePageChange = (page: number) => setCurrentPage(page);
  const handleMainSupplyClick = (supplyData: any) => {
    setSelectedSupply(supplyData);
    setIsModalOpen(true);
  };

  const currentData = mockData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div className="relative">
      {/* Modal */}
      <MainSupplyModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        items={sampleItems}
      />

      {/* Blurred content wrapper */}
      <div className="blur-sm pointer-events-none">
        <StoryboardCreatorsTable
          data={currentData}
          onMainSupplyClick={handleMainSupplyClick}
        />
        <Pagination
          currentPage={currentPage}
          totalItems={mockData.length}
          pageSize={pageSize}
          onPageChange={handlePageChange}
        />
      </div>

      {/* Overlay "Coming Soon" */}
      <div className="absolute inset-0 flex items-center justify-center">
        <h1 className="font-black text-[56px] leading-[100%] tracking-[0] text-black text-center font-extrabold">
          Coming Soon
        </h1>
      </div>
    </div>
  );
};

export default StoryboardCreator;
